<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import TempTasksRow from './TempTasksRow';
import TasksDetails from './TasksDetails';
import TasksForm from './TasksForm';
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Tasks',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TempTasksRow, TasksDetails, TasksForm, CommunicationsTable },
  data() {
    return {
      title: 'Tasks',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Tasks', to: '/tasks', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      show_subtasks: 1,
      show_notes: 1,

      subtabIndex: 0,
      rowindent: 25,
      maxdepth: 5,
      viewing: {},

      default_new_subtask: {
        status: 1,
        priority: 2,
        parent_id: '',
        project_folders: [],
        title: '',
        summary: '',
        content_type: 'doc',
        content: '',
        start_date: '',
        due_date: '',
        completed_date: '',
      },
      new_subtask: {},

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Tasks\\Models\\Task',
      },

    }
  },
  created() {
    this.new_subtask = JSON.parse(JSON.stringify(this.default_new_subtask));
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/tasks/fetchSingle', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/tasks');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_task() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/tasks/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_task() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this task?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/tasks/delete/'+this.item.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$router.push('/tasks');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    openSubTask(value) {
      this.viewing = value;
      this.$refs.modal_view_subtask.show();
    },
    createSubTask(id) {
      this.new_subtask = JSON.parse(JSON.stringify(this.default_new_subtask));
      this.new_subtask.parent_id = id;
      this.$refs.modal_add_subtask.show();
    },
    add_subtask() {
      if(!this.new_subtask.parent_id) {
        this.$noty.error("An error occurred while trying to assign this task to its parent task. Please try refreshing the page and starting again.");
        return;
      }
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/tasks/store', this.new_subtask).then(res => {
        // console.log(res);
        this.new_subtask = JSON.parse(JSON.stringify(this.default_new_subtask));
        this.$refs.modal_add_subtask.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    update_subtask() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/tasks/update', this.viewing).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.viewing = {};
        this.$refs.modal_view_subtask.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_subtask() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.viewing.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this task?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/tasks/delete/'+this.viewing.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.viewing = {};
              this.$refs.modal_view_subtask.hide();
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    complete_percentage() {
      if(this.item.start_date && this.item.due_date) {
        var startOfDate = this.moment(this.item.start_date);
        var endDate = this.moment(this.item.due_date);
        var todayDate = this.moment();
        const daysDifference = this.moment(endDate).diff(startOfDate, 'days');
        const difference = todayDate.diff(startOfDate, 'days');
        const result = Math.round((difference / daysDifference) * 100);
        return result;
      } else {
        return 0;
      }

    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-modal ref="modal_add_subtask" centered size="xl" title="Create a new task" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <b-form @submit.prevent="add_subtask">
        <div class="p-4">
          <TasksForm :item="new_subtask"></TasksForm>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-light" @click="$refs.modal_add_subtask.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
        </footer>
      </b-form>
    </b-modal>

    <b-modal ref="modal_view_subtask" centered size="xl" title="Task details" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <b-form @submit.prevent="update_subtask">
        <div class="" style="margin: 0px 27px 0px">
          <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="subtabIndex">
            <b-tab><template v-slot:title>View Task</template></b-tab>
            <b-tab><template v-slot:title>Edit task</template></b-tab>
          </b-tabs>
        </div>
        <div v-if="viewing.id">
          <div v-show="subtabIndex == 0">
            <div class="bg-gray-100 p-4">
              <TasksDetails :item="viewing"></TasksDetails>
            </div>
          </div>
          <div v-show="subtabIndex == 1">
            <div class="p-4">
              <TasksForm :item="viewing"></TasksForm>
            </div>
          </div>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-danger mr-auto ml-0" @click="delete_subtask" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Task</button>
          <button type="button" class="btn btn-light" @click="$refs.modal_view_subtask.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
        </footer>
      </b-form>
    </b-modal>

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> View task</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Edit task</template></b-tab>
    </b-tabs>

    <div v-if="item.id" class="mt-4">

      <div class="row set-sm-375">
        <div class="col-lg-4">

          <div v-if="show_notes" class="alert alert-purple small _c-pointer" @click="show_notes = 0" v-tippy content="Click to hide">
            <Icon icon="ri:close-fill" class="float-right"></Icon> Remember to check the Notes & Activities tab for updates.
          </div>
          <div v-if="item.tasks && item.tasks.length && show_subtasks" class="alert alert-purple small _c-pointer" @click="show_subtasks = 0" v-tippy content="Click to hide">
            <Icon icon="ri:close-fill" class="float-right"></Icon> Additional sub tasks listed below.
          </div>

          <div class="card-box">
            <div class="">
              <div class="mb-4">
                <label for="">Status :</label>
                <div class="alert small m-0 text-white" :class="'bg-'+(item.status == 0 ? 'danger' : item.status == 1 ? 'purple' : item.status == 2 ? 'warning' : item.status == 3 ? 'blue' : item.status == 4 ? 'success' : 'dark')">{{ (item.status == 0 ? 'Trash' : item.status == 1 ? 'Draft' : item.status == 2 ? 'Active' : item.status == 3 ? 'Hold' : item.status == 4 ? 'Complete' : '') }}</div>
              </div>
              <div class="mb-4">
                <label for="">Priority :</label>
                <div class="alert small m-0" :class="'alert-'+(item.priority == 1 ? 'teal' : item.priority == 2 ? 'light' : item.priority == 3 ? 'danger' : 'dark')">{{ (item.priority == 1 ? 'Low' : item.priority == 2 ? 'Normal' : item.priority == 3 ? 'High' : '') }}</div>
              </div>
              <div class="mb-4">
                <label for="">Created by :</label>
                <div v-if="item.user" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2">
                  <div class="row m-0">
                    <div class="_w-50 mr-2">
                      <img v-if="item.user.avatar" :src="formatImage(item.user.avatar)" class="_w-50 rounded">
                      <avatar v-else :username="item.user.name" :size="50" :rounded="false" class="rounded"></avatar>
                    </div>
                    <div class="col p-0 small">
                      <h6 class="mb-0">{{item.user.name}}</h6>
                      <div class="text-muted small _lh-16">{{item.user.email}}</div>
                      <div class="text-muted small _lh-16">{{formatPhone(item.user.phone)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <label for="">Assigned to :</label>
                <div v-for="(assign, assign_i) in item.assigned_to" :key="assign_i" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2">
                  <div class="row m-0">
                    <div class="_w-50 mr-2">
                      <img v-if="assign.avatar" :src="formatImage(assign.avatar)" class="_w-50 rounded">
                      <avatar v-else :username="assign.name" :size="50" :rounded="false" class="rounded"></avatar>
                    </div>
                    <div class="col p-0 small">
                      <h6 class="mb-0">{{assign.name}}</h6>
                      <div class="text-muted small _lh-16">{{assign.email}}</div>
                      <div class="text-muted small _lh-16">{{formatPhone(assign.phone)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <label for="">Project Folders :</label>
                <div v-for="(proj, proj_i) in item.project_folders" :key="proj_i" class="mb-2 card-box border position-relative p-1 _box-shadow-0-1-4-b-2 small">
                  <Icon icon="ri:folder-open-fill" :class="proj.status == 1 ? 'text-lighten-success' : 'text-lighten-danger'"></icon> <small>{{proj.title}}</small>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr><th class="text-nowrap border-0"><label>Created date :</label></th><td class="border-0 small">{{ item.created_at ? moment(item.created_at).format('MM-DD-YYYY') : '' }}</td></tr>
                    <tr><th class="text-nowrap"><label>Start date :</label></th><td class="small">{{ item.start_date ? moment(item.start_date).format('MM-DD-YYYY') : '' }}</td></tr>
                    <tr><th class="text-nowrap"><label>Due date :</label></th><td class="small">{{ item.due_date ? moment(item.due_date).format('MM-DD-YYYY') : '' }}</td></tr>
                    <tr><th class="text-nowrap"><label>Completed date :</label></th><td class="small">{{ item.completed_date ? moment(item.completed_date).format('MM-DD-YYYY') : '' }}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-block btn-outline-danger" @click="delete_task" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Task</button>
        </div>
        <div class="col-lg-8">

          <div v-show="tabIndex == 0">
            <div class="card-box p-4">
              <h2 class="border-left border-primary _b-s-2 pl-3 mb-4">{{item.title}}</h2>
              <p class="mb-5">{{item.summary}}</p>

              <div class="">

              </div>

              <h6 class="mb-3">Estimated progress</h6>
              <div class="progress mb-2"><div class="progress-bar progress-bar-striped bg-success" :style="'width:'+complete_percentage()+'%'"></div></div>
              <div class="row small text-muted mb-5">
                <div class="col-6 small">
                  Created: {{moment(item.created_at).format('MM-DD-YYYY')}}
                </div>
                <div class="col-6 small text-right">
                  Due: {{moment(item.due_date).format('MM-DD-YYYY')}}
                </div>
              </div>
              <div v-html="item.content"></div>
            </div>
            <div class="card-box p-0 mt-4 position-relative">
              <div class="p-4">
                <h5>Sub tasks</h5>
              </div>
              <div class="table-responsive m-0">
                <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
                  <thead class="bg-white">
                    <tr>
                      <th class="">Title</th>
                      <th class="">Status</th>
                      <th class="">Priority</th>
                      <th class="">Sub tasks</th>
                      <th class="">Assigned_to</th>
                      <th class="">Start date</th>
                      <th class="">Due date</th>
                      <th class="">Complete date</th>
                      <th class="">Created date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <TempTasksRow
                      v-for="(task, task_i) in item.tasks"
                      :key="task_i"
                      :item="task"
                      :rowindent="rowindent"
                      :depth="0"
                      :maxdepth="maxdepth"
                      :last="item.tasks.length == (task_i + 1) ? true : false"
                      @open="openSubTask"
                      @create="createSubTask"
                    ></TempTasksRow>
                  </tbody>
                </table>
              </div>
              <div class="p-3 border-top border-light">
                <button type="button" @click="createSubTask(item.id)" class="btn btn-success ml-2" :disabled="dsbl_btn"><Icon icon="ri:add-line"></Icon> Add sub task</button>
              </div>
            </div>
          </div>

          <div v-show="tabIndex == 1">
            <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
          </div>

          <div v-show="tabIndex == 2">
            <div class="card-box">
              <b-form @submit.prevent="update_task">
                <TasksForm :item="item"></TasksForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-primary ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                </div>
              </b-form>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
